import styled from "styled-components"

export const StatsItemContainer = styled.div`
  padding: 0;
`

export const StatsItemHeader = styled.p`
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  margin: 0;
  margin-bottom: 6px;
`

export const StatsItemValue = styled.p`
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  margin: 0;
  line-height: 1;
`
